import React from "react"

export function UntitledLogo({navOpened}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72.043"
      height="89.265"
      viewBox="0 0 72.043 89.265"
      className={`${navOpened ? "fade-out" : "fade-in"}`}
    >
      <defs>
        <filter
          id="Path_6"
          x="25"
          y="0"
          width="47.043"
          height="89.265"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="3" dy="4" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feFlood flood-opacity="0.271" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Path_22"
          x="0"
          y="0"
          width="47.042"
          height="89.265"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="3" dy="4" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1" result="blur-2" />
          <feFlood flood-opacity="0.271" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Layer_2" data-name="Layer 2" transform="translate(0.05 -0.9)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0)">
          <g transform="matrix(1, 0, 0, 1, -0.05, 0.9)" filter="url(#Path_6)">
            <path
              id="Path_6-2"
              data-name="Path 6"
              d="M227.52,39.062V7.2h24.864a16.179,16.179,0,0,1,16.179,16.179V73.5L254.882,89.465V28.711c0-3.134-1.315-5.255-5.675-5.67S231.231,24.787,227.52,39.062Z"
              transform="translate(-202.52 -7.2)"
              fill="#fff"
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -0.05, 0.9)" filter="url(#Path_22)">
            <path
              id="Path_22-2"
              data-name="Path 22"
              d="M268.563,57.6V89.465H243.7A16.178,16.178,0,0,1,227.52,73.287V23.166L241.2,7.2V67.954c0,3.134,1.315,5.255,5.675,5.67S264.852,71.878,268.563,57.6Z"
              transform="translate(-227.52 -7.2)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function SkipNextIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" />
    </svg>
  )
}
export function SkipPreviousIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z" />
    </svg>
  )
}
export function PlayArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  )
}
export function PauseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
    </svg>
  )
}
export function VolumeDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path d="M4 7v4h3l4 4V3L7 7H4zm9-1v6c1.17-.49 2-1.65 2-3s-.83-2.51-2-3z" />
    </svg>
  )
}
export function VolumeOffIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path d="M5 7v4h3l4 4V3L8 7H5z" />
    </svg>
  )
}
export function VolumeUpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path d="M12.79 9c0-1.3-.72-2.42-1.79-3v6c1.06-.58 1.79-1.7 1.79-3zM2 7v4h3l4 4V3L5 7H2zm9-5v1.5c2.32.74 4 2.93 4 5.5s-1.68 4.76-4 5.5V16c3.15-.78 5.5-3.6 5.5-7S14.15 2.78 11 2z" />
    </svg>
  )
}
export function ArrowDropDownIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path d="M5 8l4 4 4-4z" />
    </svg>
  )
}
